/* @ngInject */
const myContactDisplay = () => {
  return {
    restrict: 'E',
    scope: {
      myContact: '=',
    },
    template: require('./myContactDisplay.html'),

    /* @ngInject */
    controller: ($scope, utils) => {

    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myContactDisplay



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/contact/directives/display/myContactDisplay.js